"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var XButton = function XButton(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "x-button",
    onClick: function onClick(event) {
      return onClose && onClose(event);
    }
  });
};

var _default = function _default(_ref2) {
  var children = _ref2.children,
      _ref2$visible = _ref2.visible,
      visible = _ref2$visible === void 0 ? true : _ref2$visible,
      _ref2$layer = _ref2.layer,
      layer = _ref2$layer === void 0 ? 0 : _ref2$layer,
      onClose = _ref2.onClose,
      className = _ref2.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'card ' + (visible ? 'visible ' : '') + (layer ? "canBeClosed layer".concat(layer, " ") : '') + (className || '')
  }, layer > 0 ? /*#__PURE__*/_react["default"].createElement(XButton, {
    onClose: onClose
  }) : null, children);
};

exports["default"] = _default;